export function schoolGradeListByFilter(filter) {
  const query = `{schoolGradeListByFilter(filter: ${JSON.stringify(
    filter
  ).replace(
    /"([^(")"]+)":/g,
    '$1:'
  )}){id, name, active, order, educationStage{id, name, active}}}`;
  return query;
}

export function schoolGradeListAll() {
  const query =
    '{schoolGradeListAll{id, name, active, order, educationStage{id, name, active}}}';
  return query;
}

export function removeSchoolGradeMutation(id) {
  const query = `mutation {schoolGradeRemove(id: ${id})}`;
  return query;
}

export function saveSchoolGradeMutation(values) {
  const query = `mutation {
    schoolGradeSave(                              
       schoolGrade: {id: ${values.id ? values.id : 0}
                    , name: "${
                      values.name
                    }"                                            
                    , active: ${values.active}
                    , order: ${values.order}
                    , filterByStatus: false                                        
                    , updaterId: 0
                    , educationStage: {id: ${values.educationStage.id}
                                    , name: "${
                                      values.educationStage.name
                                    }"                                            
                                    , description: ""
                                    , active: true
                                    , filterByStatus: false                                        
                                    , updaterId: 0
                                    },
                }),
    {id}
  }`;
  return query;
}
